import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import SkillMasterInterface from "../../interfaces/SkillMasterInterface";

const path = "/api/v1/skill_masters/{skill_master_hashid}" as const;

const buildKey = (skillMasterId: string) => [path, skillMasterId];

export const useFetchSkillMaster = ({
  skillMasterId,
}: {
  skillMasterId: string;
}) => {
  return useQuery<SkillMasterInterface, HTTPErrors>({
    queryKey: buildKey(skillMasterId),
    queryFn: async () => {
      const { response, data } = await boronClient.GET(path, {
        params: {
          path: { skill_master_hashid: skillMasterId },
        },
      });
      if (response.ok && data) {
        return data.skillMaster;
      }
      throw await createError(response);
    },
  });
};
